// extracted by mini-css-extract-plugin
export default {"videos":"Videos_videos__pV6tX","content":"Videos_content__l-Ps4","videoWrap":"Videos_videoWrap__cQYlv","videoTitle":"Videos_videoTitle__ublHB","video":"Videos_video__ER7ch"};